<template>
    <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
        <h1>{{ msg }}</h1>
        <button @click="navigateToOffers" class="btn btn-success">Go To Offers</button>
        
    </div>
</template>

<script>
    export default {
        name: 'hello',
        data() {
            return {
                msg: 'Welcome to Offer Swap!'
            }
        },
        methods: {
            navigateToOffers() {
                this.$router.push({
                    name: 'offersList'
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1,
    h2 {
        font-weight: normal;
    }
    
    ul {
        list-style-type: none;
        padding: 0;
    }
    
    li {
        display: inline-block;
        margin: 0 10px;
    }
    
    a {
        color: #42b983;
    }
</style>



// WEBPACK FOOTER //
// Home.vue?0ec1bcfa